import AitiProductVariants from './view/variants.mjs';
import AitiProductReviews from './view/reviews';

/**
 * @class
 */
var AitiProductView = function() {

    let _this = this;

    this.init = function() {
        DeferredEvents.trigger(AitiProductView.EVENT_INIT_AFTER);
        return this;
    };

    /** @returns {AitiProductVariants} */
    this.getVariants = function() {
        return this._variants;
    };

    /** @returns {AitiProductReviews} */
    this.getReviews = function() {
        return this._reviews;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onInitAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(AitiProductView.EVENT_INIT_AFTER, handler, priority, ignoreCancel, this);
        return this;
    };

    this._variants = new AitiProductVariants(this);
    this._reviews = new AitiProductReviews();
};

/** EVENTS */
AitiProductView.EVENT_INIT_AFTER = 'product_view_init_after';

/** @type {AitiProductView} */
window.AitiProductView = new AitiProductView();

export default window.AitiProductView;
